import { install as installGoogleMaps } from "./googleMaps"
import { install as installFontAwesome } from "./fontAwesome"

export { createVueInstance } from "./createInstances"

export default function start() {
  installGoogleMaps();
  installFontAwesome();
}